export default {
    name: 'ActivationCobasPlus',

    data() {
        return {};
    }
};
